<template>
  <div class="not-found-view">
    <NavBar class="not-found-view__navbar">
      <template #left>
        <IconButton
          icon-name="ic_arrow_left"
          aria-label="Voltar"
          data-testid="back"
          @click="onClickBack"
        />
      </template>
    </NavBar>
    <main class="not-found-view__content">
      <HelperViewStatus
        class="not-found-view__content__helper-view"
        title="Página não encontrada"
        description="A página que você está procurando não existe ou não está mais disponível."
        button-label="Voltar ao início"
        status="alert"
        @click="redirectToHome"
      />
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import {
  NavBar,
  BaseIcon,
  IconButton,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    NavBar,
    BaseIcon,
    IconButton,
    HelperViewStatus
  }
})
export default class NotFoundView extends Vue {
  readonly NebraskaColors = NebraskaColors;

  onClickBack() {
    this.$router.back();
  }

  redirectToHome() {
    this.$router.push('home');
  }
}
</script>

<style lang="less" scoped>
.not-found-view {
  &__navbar {
    background: transparent;
  }
  &__content {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .to-sm({
     width: 80%;
  });
  }
}
</style>
